import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { FullPageSlotsRoute } from '@/app/FullPageSlotsRoute';
import type { PageStaticData } from '@/shared/routing';

// Runtime full-page app slots, with `NotFoundPage` when no slot owns the URL, bare `/apps` included.
// No access check: the slots the backend assigns decide at runtime which apps exist.
export const Route = createFileRoute('/_authenticated/apps/$')({
    // No chrome: `FullPageAppLayout` is the product rail alone, so the `NotFoundPage` fallback has no navbar either.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    // The widget's path and fragment come from the match, like the query string `FullPageSlots` reads from it: the
    // router's location moves as soon as a navigation away starts. `beforeLoad` runs on every load, a fragment-only
    // one included. The path is the URL's own: the match's `pathname`, rebuilt from the decoded splat, turns a
    // widget param's `%2F` into another segment.
    beforeLoad: ({ location }) => ({ urlPathname: location.href.split(/[?#]/, 1)[0], urlHash: location.hash }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const urlPathname = Route.useRouteContext({ select: (context) => context.urlPathname });
    const urlHash = Route.useRouteContext({ select: (context) => context.urlHash });
    return <FullPageSlotsRoute pathname={urlPathname} hash={urlHash} />;
}
